import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { constants } from '../../modules/utils/constants/constants';
interface AwpTabContainerProps {
  tabWidth?: string;
}

export const StyledTabContainer = styled.div<AwpTabContainerProps>`
  padding-top: ${toRem(24)};

  .m-standard-tab-list-item {
    width: ${props => (props?.tabWidth ? `${props?.tabWidth} !important` : 'initial')};
  }

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    padding-top: unset;
  }

  /* ${rtl`
    // &:is(${constants.RTL_LANG_LIST}) {      
      // .m-standard-tab-list {
        // width: 100% !important;
        // transition: none !important;
        // transform: none !important;
      // }

      // .glide > .center-align {
        // display: none !important;
      // }

      // .m-standard-tab-list .m-standard-tab-list-item {
        // margin-left: 1rem;
      // }

      // @media ${baseVariables.mediaQuery.sm} {
        // .m-standard-tab-list {
          // width: unset;
        // }

        // .glide > .center-align {
          // display: unset;
        // }

        // .m-standard-tab-list .m-standard-tab-list-item {
          // margin-left: unset;
        // }
      // }
    // }
  `} */
`;
